const googleTagManagerId = {
  Landing_Logo_Button: "landing_logo_button",
  LandingMain_SignIn_Button: "landing-main_sign-in_button",
  LandingMain_EmailAddress_Input: "landing-main_email-address_input",
  LandingMain_RequestAccess_Button: "landing-main_request-access_button",
  LandingSignIn_EmailAddress_Input: "landing-sign-in_email-address_input",
  LandingSignIn_GoogleSignIn_Button: "landing-sign-in_google-sign-in_button",
  LandingSignIn_SignIn_Button: "landing-sign-in_sign-in_button",
  SurveyRequestModal_StartSurvey_Button:
    "survey-request-modal_start-survey_button",
};

export default googleTagManagerId;
